import { render, staticRenderFns } from "./AssetDetailIcon.vue?vue&type=template&id=6a7a1491&"
import script from "./AssetDetailIcon.vue?vue&type=script&lang=js&"
export * from "./AssetDetailIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports